import { matchPath, useLocation } from 'react-router'
import { Link } from 'react-router-dom'
import React from 'react'
import PropTypes from 'prop-types'
import BEMHelper from '@ynap/bem-helper'

const classNames = new BEMHelper('PreviousPageLink')

const propTypes = {
    links: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            to: PropTypes.string,
            parent: PropTypes.string,
        })
    ),
    messages: PropTypes.shape({
        pages: PropTypes.object.isRequired,
    }).isRequired,
    params: PropTypes.object,
    location: PropTypes.shape({
        pathname: PropTypes.string,
    }),
    className: PropTypes.string,
}

function replaceParams(link, params) {
    let result = link
    for (var name in params) {
        const pattern = ':' + name
        result = link.replace(pattern, params[name])
    }
    return result
}

function PreviousPageLink(props) {
    const { links, messages, className, params, title } = props

    let { location } = props
    location = location || useLocation()

    const currentPage = links?.find((link) => {
        const isMatch = link.to && matchPath(location.pathname, { path: link.to, exact: true })
        return isMatch ? link : null
    })

    const parent = currentPage ? currentPage.parent : undefined
    const prevPage = links?.find((link) => (parent ? link.id === parent : null))

    let toLink = null

    if (params && prevPage) {
        toLink = replaceParams(prevPage.to, params)
    } else if (prevPage) {
        toLink = prevPage.to
    }

    return (
        <div className={classNames(null, null, className)}>
            {toLink ? (
                <Link className={classNames('link')} to={toLink}>
                    {title || messages.pages[prevPage.id].title()}
                </Link>
            ) : null}
        </div>
    )
}

PreviousPageLink.propTypes = propTypes

export default PreviousPageLink
